import {
  SET_REVIEWS,
  SET_REVIEW,
  CLEAR_REVIEWS,
  CLEAR_REVIEW,
  ADD_REVIEW,
  UPDATE_REVIEW,
  REMOVE_REVIEW,
} from './actionTypes';

export const review = (state = {}, action) => {
  switch (action.type) {
    case SET_REVIEW:
      return action.payload;
    case UPDATE_REVIEW:
      if (state._id.toString() !== action.payload._id.toString()) {
        return state;
      }

      // Otherwise, this is the one we want - return an updated value
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_REVIEW:
      return {};
    default:
      return state;
  }
};

export default (state = [], action) => {
  switch (action.type) {
    case SET_REVIEWS:
      return action.payload;
    case ADD_REVIEW:
      return [...state, action.payload];
    case UPDATE_REVIEW:
      return state.map((item) => {
        if (item._id !== action.payload._id) {
          return item;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...item,
          ...action.payload,
        };
      });
    case REMOVE_REVIEW:
      return state.map((item) => {
        if (item._id !== action.payload._id) {
          return item;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...item,
        };
      });
    case CLEAR_REVIEWS:
      return [];
    default:
      return state;
  }
};
